import React, { useCallback } from 'react';
import { SpreadsheetDocumentsData } from '../../models/SpreadsheetDocument';
import {
  MaterialSpreadsheetService,
  DEFAULT_MATERIAL_COLUMNS,
} from '../../services/MaterialSpreadsheetService';
import SpreadsheetDocuments from '../../components/spreadsheet-docs/SpreadsheetDocuments';
import { getUserInfo } from '../../utils/auth';

interface MaterialDocumentsSectionProps {
  projectId: number;
}

/**
 * 자재 문서(엑셀) 섹션 — 자재 관리 페이지 하단.
 *
 * 위쪽 구조화 자재 테이블(MaterialsSection)과는 별개로, 업로드한 자재 엑셀을
 * 제목 토글 문서로 보관·편집·내보내기·삭제한다. 저장은 projects.material_spreadsheet.
 * 편집은 admin/editor 만.
 */
const MaterialDocumentsSection: React.FC<MaterialDocumentsSectionProps> = ({ projectId }) => {
  const role = getUserInfo()?.role;
  const writable = role === 'admin' || role === 'editor';

  const load = useCallback(() => MaterialSpreadsheetService.get(projectId), [projectId]);
  const save = useCallback(
    (data: SpreadsheetDocumentsData) => MaterialSpreadsheetService.update(projectId, data),
    [projectId],
  );

  return (
    <SpreadsheetDocuments
      load={load}
      save={save}
      writable={writable}
      title="자재 문서 (엑셀)"
      description="💡 업로드한 자재 엑셀은 제목 토글로 접었다 펼칠 수 있는 별도 문서로 보관됩니다. 위쪽 '자재 관리' 표(요약 위젯 연동)와는 별개입니다. 셀 직접 편집·제목 변경·엑셀 내보내기·삭제가 가능하며 모든 변경은 자동 저장됩니다."
      defaultColumns={DEFAULT_MATERIAL_COLUMNS}
      newDocName="자재 문서"
      exportPrefix="material"
    />
  );
};

export default MaterialDocumentsSection;
